// import VersionManagement from "../views/systemManagement/versionManagement";
// import ApplicationManagement from "../views/systemManagement/applicationManagement";
import Main from "../views/main";
import ResourceManage from "../views/videoManagement/resourceManage";
// import LineCheck from "../views/videoManagement/lineCheck";

const SystemRouter = {
  path: "/version-management",
  component: Main,
  title: "系统管理",
  icon: "el-icon-s-tools",
  meta: { keepAlive: false },
  children: [
    {
      path: "/resource-management",
      component: ResourceManage,
      name: "resourceManage",
      title: "APP配置",
      meta: { title: "APP配置", keepAlive: true },
    },
    // {
    //   path: "/line-check",
    //   component: LineCheck,
    //   name: "lineCheck",
    //   title: "线路排查",
    //   meta: { title: "线路排查", keepAlive: true },
    // },
    // {
    //   path: "/version-management",
    //   component: VersionManagement,
    //   name: "versionManagement",
    //   title: "版本管理",
    //   meta: { title: "版本管理", keepAlive: true },
    // },
    // {
    //   path: "/application-management",
    //   component: ApplicationManagement,
    //   name: "applicationManagement",
    //   title: "应用管理",
    //   meta: { title: "应用管理", keepAlive: true },
    // },
  ],
};
export default SystemRouter;
